// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CommentIndicator {\n  position: absolute;\n  z-index: 1;\n  transform: translate(50%, 70%);\n  width: 200px;\n  color: #484848;\n  font-weight: 300;\n}\n\n.ArrowIconContainer {\n  float: left;\n  margin-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
